import { useQuery } from "@tanstack/react-query";
import { Radio } from "antd";
import { useState } from "react";
import { getInsightsHeadline } from "../actions/acc_actions";
import Loading from "../utils/Loading";

const options = [
  { label: "Day", value: "day" },
  { label: "Week", value: "week" },
  { label: "Month", value: "month" },
  { label: "Year", value: "year" },
];

export default function InsightsSummary({ selectedSchema }) {
  const [value, setValue] = useState("day");

  const {
    isLoading,
    data: insightsData,
    isFetching,
  } = useQuery({
    queryKey: ["insightsHeadline", value, selectedSchema],
    queryFn: () =>
      getInsightsHeadline({
        refresh: false,
        period: value,
        loyalty_scheme_slug: selectedSchema,
      }),
    enabled: !!value && !!selectedSchema,
  });

  const data = insightsData?.body?.data;

  if (!data || isLoading) return <Loading />;

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const cards = [
    {
      title: "total customers",
      data: data.total_customers,
      imgClass: "img-mov",
      imgSrc: "/assets/images/icons/insights/group.png",
    },
    {
      title: "total stamps",
      data: data.total_stamps,
      imgClass: "img-pink",
      imgSrc: "/assets/images/icons/insights/path.png",
    },
    {
      title: "total vouchers",
      data: data.total_vouchers_awarded,
      imgClass: "img-orange",
      imgSrc: "/assets/images/icons/insights/reward.png",
    },
    {
      title: "total visits",
      data: data.total_visits,
      imgClass: "img-yellow",
      imgSrc: "/assets/images/icons/insights/loc.png",
    },
  ];

  return (
    <div className="insights_summary-container">
      <div className="insights_summary">
        <div className="radio-container">
          <h4>Your headline stats for:</h4>
          <Radio.Group
            onChange={onChange}
            value={value}
            options={options}
            optionType="button"
            buttonStyle="solid"
          />
        </div>
        <div className="insights_summary-cards">
          {isFetching || isLoading || !data ? (
            <Loading />
          ) : (
            cards.map((card, index) => (
              <div className="insights_summary-card" key={index}>
                <div className="insights_summary-card-header">
                  <div>
                    <h5>{card.title}</h5>
                    <h3>{formatNumber(Number(card.data.value))}</h3>
                  </div>
                  <div className={`img-container ${card.imgClass}`}>
                    <img src={card.imgSrc} alt={card.title} />
                  </div>
                </div>
                <div>
                  <h6>
                    <img
                      src="/assets/images/icons/insights/arrow.png"
                      alt="trend"
                    />
                    <span
                      className={
                        card.data.percentage_change >= 0 ? "active" : "negative"
                      }
                    >
                      {typeof card.data.percentage_change === "number"
                        ? ` ${Number(card.data.percentage_change).toFixed(2)}%`
                        : "N/A"}
                    </span>{" "}
                    {card.data.percentage_change >= 0 ? "Up" : "Down"} from
                    previous period
                  </h6>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
